

const getAcitvity = (state) => state.activity;

const getLastAcitivityTime = (state) => getAcitvity(state).lastActionTime;

export default getLastAcitivityTime;


